module.exports = __webpack_public_path__ + "static/img/topic-top.bfd0a44.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/topic-top.png
// module id = Zpdf
// module chunks = 36